<template lang="pug">
main.app-main
    div.wam-content.app-settings(
        v-if="hasUserAccessToSettings"
        :class="{'full-width': isLoading }")

        //- Loading data
        template(v-if="isLoading")
            spinner.l-flex-row--center.l-align-center(width="200" height="200")

        template(v-else)

            //- LEFT PANEL
            div.settings-menu
                div.settings-category
                    sectionHeader(title="Settings")
                    ul.settings-list
                        li.settings-item(
                            @click="selectSetting('general')"
                            :class="{'is-active': settingsMenu === 'general'}") General
                        li.settings-item(
                            @click="selectSetting('socio-demos')"
                            :class="{'is-active': settingsMenu === 'socio-demos'}") Socio-demographics
                        li.settings-item(
                            @click="selectSetting('wamfactory')"
                            :class="{'is-active': settingsMenu === 'wamfactory'}")
                                span Wamfactory
                                div.settings-item-state(:class="{'is-active': uiWamFactoSettings.wamfactory }")
                                    span
                        li.settings-item(
                            @click="selectSetting('datamining')"
                            :class="{'is-active': settingsMenu === 'datamining'}")
                            span Datamining
                            div.settings-item-state(:class="{'is-active': uiDataminingSettings.datamining }")
                                span
                        li.settings-item(
                            @click="selectSetting('extra-taxos')"
                            :class="{'is-active': settingsMenu === 'extra-taxos'}") Extra taxonomies
                        li.settings-item(
                            @click="selectSetting('sharing')"
                            :class="{'is-active': settingsMenu === 'sharing'}") Sharing                        
                        li.settings-item(
                            v-if="isWeboAdmin || isWeboEmployee"
                            @click="selectSetting('business-apps')"
                            :class="{'is-active': settingsMenu === 'business-apps'}") Business Apps

            //- MIDDLE PANEL
            div.settings-content
                //- GENERAL SECTION
                GeneralSettings.settings-content-general(v-if="showSettings")

                //- SOCIO-DEMO SECTION
                SocioDemoSettings.settings-content-general(v-show="settingsMenu === 'socio-demos'")

                //- WAMFACTORY SECTION
                WamFactorySettings.settings-content-general(v-if="settingsMenu === 'wamfactory'" )

                //- DATAMINING SECTION
                DataminingSettings.settings-content-general(v-if="settingsMenu === 'datamining'")

                //- EXTRA-TAXONOMIES SECTION
                ExtraTaxonomiesSettings.settings-content-general(
                    v-show="settingsMenu === 'extra-taxos'"
                    @activeSocioDemo="selectSetting('socio-demos')")

                //- SHARING SECTION
                SharingSettings.settings-content-general(v-if="settingsMenu === 'sharing'")
                
                //- BUSINESS APPS SECTION
                BusinessAppsSettings.settings-content-general.settings-business-apps-section(v-if="settingsMenu === 'business-apps'")


</template>

<script>
//components
import Table from '@/components/common/Table'
import ConfirmationModal from '@/components/common/confirmationModal'
import SectionHeader from '@/components/common/SectionHeader'
import SwitchItem from '@/components/common/SwitchItem'
import BusinessAppsSettings from '@/components/settings/BusinessAppsSettings'
import GeneralSettings from '@/components/settings/GeneralSettings'
import SocioDemoSettings from '@/components/settings/SocioDemoSettings'
import WamFactorySettings from '@/components/settings/WamFactorySettings'
import DataminingSettings from '@/components/settings/DataminingSettings'
import ExtraTaxonomiesSettings from '@/components/settings/ExtraTaxonomiesSettings'
import SharingSettings from '@/components/settings/SharingSettings'

//store
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import { get, isEmpty, isNil } from 'lodash'

export default {
    name: 'Settings',
    beforeRouteLeave(to, from, next) {
        if (!isNil(this.uiSettingName)) {
            this.setSettingName({ name: null })
        }
        next()
    },
    components: {
        ConfirmationModal,
        SectionHeader, 
        SwitchItem,
        Table,
        BusinessAppsSettings,
        GeneralSettings,
        SocioDemoSettings,
        WamFactorySettings,
        DataminingSettings,
        SharingSettings,
        ExtraTaxonomiesSettings,
    },

    data() {
        return {
            settingsMenu: 'general',
        }
    },

    computed: {
        ...mapState('account', {
            userRole: state => state.userRole,
        }),
        ...mapState('ui/settings', {
            uiSettingName: state => state.settingName,
            uiDataminingSettings: state => state.dataMining,
            uiWamFactoSettings: state => state.wamFactory,

        }),
        ...mapState('data/settings', {
            sharingSettings: state => state.sharing
        }),
        ...mapGetters('account', ['getAccessToSettings']),
        ...mapGetters('ui/builder', ['criteriaListIsReady']),

        isLoading() {
            return !this.criteriaListIsReady
        },

        isWeboAdmin() {
            return this.userRole === 'webo_admin'
        },
        isWeboEmployee() {
            return this.userRole === 'webo_employee'
        },

        showSettings() {
            return this.settingsMenu === 'general' && (this.isWeboAdmin || this.isWeboEmployee)
        },

        hasUserAccessToSettings() {
            return this.getAccessToSettings()
        },
    },

    mounted() {
        window.addEventListener('hook:settings', () => {
            this.selectSetting('general')
        })
    },

    destroyed() {
        window.removeEventListener('hook:settings', () => {})
    },

    methods: {
        ...mapActions('data/settings', ['retrieveLinkedAccounts','retrieveExtraTaxos']),

        ...mapMutations('ui/settings', ['setSettingName', 'setLoading']),


        selectSetting(setting) {
            this.settingsMenu = setting
            //call API to retrieve extra-taxonomies
            if (setting === 'extra-taxos' && isEmpty(this.extraTaxoList)) {
                this.retrieveExtraTaxos().then(() => {
                    this.currentExtraTaxo = get(this.extraTaxoList, 'wb', [])
                })
            }
            if (setting === 'sharing' && isEmpty(this.sharingSettings.taxonomies)) {
                this.setLoading(true)
                this.retrieveLinkedAccounts().then(() => {
                    this.setLoading(false)
                })
            }
        },
    }
}
</script>
